<template>
    <div>
        <link
            v-for="asset in customAssets"
            rel="stylesheet"
            :href="asset"
            :media="loaded.includes(asset) ? 'all' : 'print'"
            @load="() => loaded.push(asset)"
        />
        <ElConfigProvider :locale="elementLocale">
            <ExtendSession
                v-if="$store.userSessionDuration && $store.userSessionLastAccessed"
                :user-session-duration="$store.userSessionDuration"
                :user-session-last-accessed="$store.userSessionLastAccessed"
            />
            <div v-if="loading" id="portal-header" class="unselectable">
                <div id="login-logo"></div>
                <div style="position: fixed; top: calc(50% - 22px); left: calc(50% - 63px)">
                    <div id="loading_spinner"></div>
                </div>
            </div>
            <div v-else :class="{ darkMode: $store.darkMode }">
                <AppHeader />
                <div id="content">
                    <div
                        :class="{
                            PageContent: $store.user.userId && $route.path !== '/login/tree' && $route.path !== '/menu',
                        }"
                    >
                        <keep-alive>
                            <router-view
                                v-if="$route.meta.keepAlive && $route.meta.hasOwnProperty('keepAliveKey')"
                                :key="$route.meta.keepAliveKey"
                            />
                            <router-view v-else-if="$route.meta.keepAlive" :key="$route.path" />
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive" :key="$route.path" />
                    </div>
                </div>
                <AppFooter />
            </div>
        </ElConfigProvider>
    </div>
</template>

<script>
    import { ElConfigProvider } from 'element-plus';
    import AppHeader from '@/feature/header/AppHeader';
    import AppFooter from '@/feature/header/AppFooter';
    import ExtendSession from '@/components/ExtendSession';
    import { element } from '@/utils/ElementPlus';
    import { post, resetStore } from '@/utils/Http';
    import { findLocale, setLocale } from '@/i18n';

    export default {
        name: 'PortalApp',
        components: {
            AppFooter,
            AppHeader,
            ElConfigProvider,
            ExtendSession,
        },
        data() {
            return {
                customAssets: [],
                defaultLocale: 'en',
                loading: true,
                loaded: [],
            };
        },
        computed: {
            elementLocale() {
                return element[localStorage.user_lang || this.defaultLocale];
            },
        },
        created() {
            this.loadUser();
        },
        methods: {
            loadUser() {
                this.loading = true;
                const urlParams = new URLSearchParams(window.location.search);
                const requestLocale = urlParams.get('lang');

                post(
                    'user/authenticated2',
                    { lang: requestLocale || localStorage['iso_639-1_lang'] },
                    async (response) => {
                        const path = window.location.pathname.split('/');
                        const loginPath =
                            (path[2].substring(0, 5) === 'login' || path[2] === 'message') &&
                            (path.length < 4 || path[3].substring(0, 4) !== 'tree');
                        this.defaultLocale = response.defaultLocale;

                        if (response.user && !loginPath) {
                            // Commit user rights and the security token to the global store so that they're accessible to other
                            // components.
                            this.$store.setUser(response.user);
                            this.$store.menu = response.menu;
                        } else {
                            resetStore();
                            if (this.$route.path !== '/login' && this.$route.name !== 'ssologin') {
                                this.$router.push('/login');
                            }
                        }

                        this.customAssets = (response.assets || [])
                            .filter((asset) => asset.substring(asset.length - 4) === '.css')
                            .map((asset) => asset.replace('{server.name}', window.location.host));
                        this.$store.systemUse = response.systemUse;
                        this.$store.setHelpLinks({
                            helpLink: response.helpLink,
                            themeName: response.themeName,
                            defaultLocale: response.defaultLocale,
                        });
                        const locale = findLocale(requestLocale, response.defaultLocale);
                        await setLocale(locale, response.translations);

                        this.loading = false;
                    },
                );
            },
        },
    };
</script>
